import { render, staticRenderFns } from "./FormInput.vue?vue&type=template&id=2bc3be20&"
import script from "./FormInput.vue?vue&type=script&lang=js&"
export * from "./FormInput.vue?vue&type=script&lang=js&"
import style0 from "./FormInput.vue?vue&type=style&index=0&id=2bc3be20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports